import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js"
// カレンダーの日本語化
// カレンダー表示
var day = new Date();
var year = day.getFullYear();
var nextYear = year + 1;
console.log(year)
flatpickr("input[type='date']", {
  // スマートフォンでもカレンダーに「flatpickr」を使用する設定
  disableMobile: true,
  dateFormat: "Y-m-d",
  minDate: "today",
  "locale": Japanese, // このインスタンスのみの言語指定
  // maxDate: new Date().fp_incr(14), // 14 days from now
  minDate: new Date().fp_incr(3),
  "disable": [
    {
      from: year + "-12-31",
      to: nextYear + "-01-03"
    },
  ],
    //今日までを選択可能にする
    // maxDate: 3,
  })
